import React from 'react';
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  ComposedChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
  Line,
  Legend,
} from 'recharts';
import { Box, Text } from 'grommet';

const DomainTrafficChart = ({
  data,
  isEventDay = false,
  primaryText = 'var(--page-primary-text)',
  secondaryText = 'var(--page-secondary-text)',
  chartTooltip,
}) => (
  <Box direction="column" gap="1rem">
    <Box direction="column" gap="0.5rem">
      <Text color={primaryText} size="1rem" weight={700}>
        {isEventDay ? 'Domain Violations vs Traffic' : 'Top Sites by Infringements'}
      </Text>
      <Text color={secondaryText} size="0.8rem">
        {isEventDay
          ? 'Top domains by infringements and visitors (thousands)'
          : 'Top infringing domains before event-day escalation.'}
      </Text>
      {isEventDay && (
        <Text size="0.68rem" color="#B9DCE8">
          Traffic data sourced from platforms like SimilarWeb and Semrush.
        </Text>
      )}
    </Box>
    <Box height="19rem" width="100%">
      <ResponsiveContainer width="100%" height="100%">
        {isEventDay ? (
          <ComposedChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E6EEF6" />
            <XAxis dataKey="domain" tick={{ fill: '#5D738A', fontSize: 11 }} />
            <YAxis yAxisId="left" tick={{ fill: '#5D738A', fontSize: 11 }} />
            <YAxis yAxisId="right" orientation="right" tick={{ fill: '#5D738A', fontSize: 11 }} />
            <Tooltip {...chartTooltip} />
            <Legend />
            <Bar yAxisId="left" dataKey="infringements" name="Infringements" fill="#0EA5A2" radius={[4, 4, 0, 0]} />
            <Line yAxisId="right" type="monotone" dataKey="monthlyVisitors" name="Visitors (K)" stroke="#2563EB" strokeWidth={3} dot={{ r: 3 }} />
          </ComposedChart>
        ) : (
          <ComposedChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E6EEF6" />
            <XAxis dataKey="domain" tick={{ fill: '#5D738A', fontSize: 11 }} />
            <YAxis tick={{ fill: '#5D738A', fontSize: 11 }} />
            <Tooltip {...chartTooltip} />
            <Bar dataKey="infringements" fill="#0EA5A2" radius={[4, 4, 0, 0]} />
          </ComposedChart>
        )}
      </ResponsiveContainer>
    </Box>
  </Box>
);

DomainTrafficChart.propTypes = {
  data: PropTypes.array.isRequired,
  isEventDay: PropTypes.bool,
  primaryText: PropTypes.string,
  secondaryText: PropTypes.string,
  chartTooltip: PropTypes.object.isRequired,
};

export default DomainTrafficChart;
